// Behaviors
// require('./behaviors/01.menu-mobile');
require("./behaviors/02.image-bg");
require("./behaviors/03.anchor-link");
// require("./behaviors/04.fancybox");
// require("./behaviors/06.whatsapp");
require("./behaviors/07.carousel-customers");
require("./behaviors/09.carousel-testimony");
require("./behaviors/20.masks");